// Filter
const commonFilter = [
    // {colMd: "1", label: "User Id", type: "number", name: "id"},
];
const filterData = [
    {colMd: "3", label: "User Id", type: "number", name: "id"},
    {colMd: "3", label: "Class", type: "multi-select", name: "class_id"},
    {colMd: "3", label: "Name", type: "text", name: "name"},
    {colMd: "3", label: "Email", type: "text", name: "email"},
    {colMd: "3", label: "Mobile No.", type: "number", name: "mobile_number"},
    // {colMd: "3", label: "Country", type: "multi-select", name: "country_id"},
    // {colMd: "3", label: "State", type: "multi-select", name: "state_id"},
    // {colMd: "3", label: "City", type: "multi-select", name: "city_id"},
    {colMd: "3", label: "Competition Applied", type: "multi-select", name: "competition_id"},
    {colMd: "2", label: "PORT Completion %", type: "select", name: "completion_id"},
    {colMd: "2", label: "Member Type", type: "select", name: "member_type"},
    // {colMd: "3", label: "Payment Validity Days", type: "select", name: "validity_id"},
    // {colMd: "3", label: "PORT Pending Section", type: "multi-select", name: "port_pending_id"},
    // {colMd: "3", label: "PORT Filled Section", type: "multi-select", name: "port_filled_id"},
    {colMd: "2", label: "Status", type: "select", name: "active_status_id"},
    // {colMd: "3", label: "Registered Date", type: "date", name: "created_at", date_type: "past"}
];

const studentFilter = [
    ...commonFilter,
    {colMd: "1", label: "User Id", type: "number", name: "id"},
    {colMd: "2", label: "Name", type: "text", name: "name"},
    {colMd: "3", label: "School", type: "multi-select", name: "school_id"},
    {colMd: "3", label: "Branch", type: "multi-select", name: "branch_id"},
    {colMd: "3", label: "Class", type: "multi-select", name: "class_id"},
    {colMd: "3", label: "Email", type: "text", name: "email"},
    {colMd: "3", label: "Mobile No.", type: "number", name: "mobile_number"},
    {colMd: "3", label: "Country", type: "multi-select", name: "country_id"},
    {colMd: "3", label: "State", type: "multi-select", name: "state_id"},
    {colMd: "3", label: "City", type: "multi-select", name: "city_id"},
    {colMd: "3", label: "PORT Completion %", type: "select", name: "completion_id"},
    {colMd: "3", label: "PORT Expiry Date", type: "select", name: "validity_id"},
    {colMd: "3", label: "Competition Applied", type: "select", name: "competition_id"},
    {colMd: "3", label: "PORT Pending Section", type: "multi-select", name: "port_pending_id", sub_select: true, sub_select_key: "port_pending_oper"},
    {colMd: "3", label: "PORT Filled Section", type: "multi-select", name: "port_filled_id", sub_select: true, sub_select_key: "port_filled_oper"},
    {colMd: "2", label: "Member Type", type: "select", name: "member_type"},
    {colMd: "2", label: "Status", type: "select", name: "active_status_id"},
    {colMd: "2", label: "Registered Date", type: "date", name: "created_at", date_type: "past"}
];

const studentFilterPrin = [
    ...commonFilter,
    ...filterData
];

const studentFilterTeach = [
    ...commonFilter,
    ...filterData
];
//Filter
const filterInitial= {
    // id: "",
    // school_id: "",
    // class_id: "",
    // name: "",
    // email: "",
    // mobile_number: "",
    // country_id: "",
    // state_id: "",
    // city_id: "",
    // member_type: "",
    // completion_id: "",
    // validity_id: "",
    // competition_id: "",
    // port_pending_id: "",
    // port_filled_id: "",
    // active_status_id: "",
    // created_at: "",
    mobile_code_id: {id: 101, phone_code: "91"},
    port_pending_oper: {id: 'OR', oper: "OR"},
    port_filled_oper: {id: 'OR', oper: "OR"}
}
// const filterInitialTeach= {
//     id: "",
//     class_id: "",
//     name: "",
//     email: "",
//     mobile_number: "",
//     member_type: "",
//     completion_id: "",
//     competition_id: "",
//     active_status_id: "",
//     mobile_code_id: {id: 101, phone_code: "91"}
// }
const fieldValidPinStu = {
    title: 'required|max:100',
    user_id: 'required||User Id',
    pin_stu_id: 'optional||Pinned Student Id',
  };
const fieldValidPinStuStatus = {
    active_status_id: 'required||Opportunity Type',
    pin_stu_id: 'required||Pinned Student Id',
};
const fieldPinStu = [
    {colMd: "12", label: "User Id", required: true, type: "number", name: "user_id", min: 1},
    {colMd: "12", label: "Title", required: true, type: "textarea", name: "title", count: 100},
];

const docTypeIds = {
    edu: 1,
    exp: 2,
    award: 3,
    sport: 4,
    lifeExp: 5,
    research: 6
};
// Registration: Excel Upload
const fieldStuRegCmnTop = [
    {colMd: "6", required: true, label: "Country", type: "select", name: "country_id"}
];
const fieldStuRegCmnBtm = [
    // {colMd: "3", required: true, label: "Subscription Type", type: "multi-select", name: "subscription_id"},
    // {colMd: "3", required: true, label: "Subscription From", type: "date", name: "subs_from", date_type: "future"},
    {colMd: "3", required: true, label: "Subscription End Date", type: "date", name: "subs_to", date_type: "future"},
    {colMd: "9", required: true, label: "Excel File", type: "file", name: "excel_file", file_type: ".xlsx, .xls", tagline: "Please populate the latest downloaded Template File (it now has an optional ESG Level column) and upload it, otherwise account creation will fail or info will be wrongly filled. Glosco Year/Level is mandatory only for the Glosco subscription."}
];
const fieldStuRegInd = [
    ...fieldStuRegCmnBtm,
    ...fieldStuRegCmnTop,
    {colMd: "6", required: false, label: "State", type: "select", name: "state_id"},
    {colMd: "6", required: false, label: "Institution Type", type: "select", name: "institute_type_id"},
    {colMd: "6", required: false, label: "School/College/Organisation", type: "select", name: "school_id"},
    {colMd: "6", required: false, label: "Branch", type: "select", name: "branch_id"},
];
const fieldStuReg = [
    ...fieldStuRegCmnBtm,
    ...fieldStuRegCmnTop,
    {colMd: "6", required: false, label: "School/College/Organisation", type: "select", name: "school_id"},
];
// const oppSubsPlan = [
//     {id: 1, service: "PORT"},
//     {id: 4, service: "PORT+GLOSCO"},
//     // {id: 5, service: "GLOSCO"},
//     {id: 2, service: "Social Start-up (SS)"}
// ];
const oppInstituteTypes = [
    {id: 1, type: 'School'},
    {id: 2, type: 'College'},
    {id: 3, type: 'Organisation'},
    // {id: 0, type: 'Others'}
];
const fieldValStuReg = {
    school_id: '',
    branch_id: '',
    country_id: '',
    // country_id: {id: 101, name: "India"},
    state_id: '',
    // subscription_id: '',
    // subs_from: '',
    subs_to: '',
    excel_file: '',
    excel_file_data: '',
    // institute_type_id: {id: 1, type: "School"}
    institute_type_id: ''
  };
const fieldValidStuReg = {
    school_id: 'optional||School/College/Organisation',
    branch_id: 'optional||Branch',
    country_id: 'required||Country',
    // subscription_id: 'required||Subscription Type',
    // subs_from: 'required||Subscription From',
    subs_to: 'required||Subscription End Date',
    excel_file: 'required'
};
const fieldValidStuStuInd = {
    ...fieldValidStuReg,
    state_id: 'optional||State',
};

const data = {
    studentFilter,
    studentFilterPrin,
    studentFilterTeach,
    filterInitial,
    fieldValidPinStu,
    fieldValidPinStuStatus,
    fieldPinStu,
    docTypeIds,
    // filterInitialTeach,
    fieldStuRegInd,
    fieldStuReg,
    // oppSubsPlan,
    fieldValStuReg,
    fieldValidStuReg,
    fieldValidStuStuInd,
    oppInstituteTypes
};

export default data;